import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { DataSubscriptionConceptsActions } from "./subscription-concepts.actions";

// **************************************************************************
// SUBSCRIPTION CONCEPTS REDUCER
// **************************************************************************

const load = on(DataSubscriptionConceptsActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        subscriptionConcept: {
            ...state.data.subscriptionConcept,
            subscriptionConceptsLoading: true,
        },
    },
}));

const loadSuccess = on(DataSubscriptionConceptsActions.loadSuccess, (state: ApplicationStore, { subscriptionConcepts }) => ({
    ...state,
    data: {
        ...state.data,
        subscriptionConcept: {
            ...state.data.subscriptionConcept,
            subscriptionConcepts,
            subscriptionConceptsLoading: false,
        },
    },
}));

const loadFailure = on(DataSubscriptionConceptsActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        subscriptionConcept: {
            ...state.data.subscriptionConcept,
            subscriptionConceptsLoading: false,
        },
    },
}));

export const subscriptionConceptsReducer = [load, loadSuccess, loadFailure];
